(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  let pending = false;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-salon-cookie-settings]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    let status = link.nextElementSibling;
    if (!status || !status.hasAttribute('data-salon-cookie-status')) {
      status = document.createElement('span');
      status.setAttribute('data-salon-cookie-status', '');
      status.setAttribute('role', 'status');
      status.style.display = 'block';
      link.insertAdjacentElement('afterend', status);
    }
    status.textContent = link.dataset.loadingMessage;
    link.setAttribute('aria-busy', 'true');
    let timeout;
    try {
      await Promise.race([
        (async () => {
          for (let attempt = 0; attempt < 20; attempt++) {
            if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
              await window.privacyBanner.showPreferences();
              return;
            }
            await new Promise((resolve) => setTimeout(resolve, 250));
          }
          throw new Error('Cookie preferences unavailable');
        })(),
        new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Cookie preferences timeout')), 6000); })
      ]);
      status.textContent = '';
    } catch (_) {
      status.textContent = link.dataset.errorMessage;
    } finally {
      clearTimeout(timeout);
      link.removeAttribute('aria-busy');
      pending = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  if (!('IntersectionObserver' in window)) return;
  const observed = new WeakSet();
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    visible.forEach(element => { if (!element.isConnected) visible.delete(element); });
    document.body.classList.toggle('salon-buy-area-visible', visible.size > 0);
  }, { rootMargin: '70px 0px 70px 0px' });
  const observe = () => {
    document.querySelectorAll('[data-salon-purchase]').forEach(element => {
      if (!observed.has(element)) {
        observed.add(element);
        observer.observe(element);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-salon-purchase]').forEach(element => {
      observer.unobserve(element);
      observed.delete(element);
      visible.delete(element);
    });
    document.body.classList.toggle('salon-buy-area-visible', visible.size > 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
